import styled from 'styled-components';
import tw from 'twin.macro';
import MutualAgreementSigns from '../mutualAgreementSigns';
const FinalSectionContainer = styled.div`
  ${tw`p-0 mb-6`}
`;

const NoticeToBuyer = styled.div`
  ${tw`border border-gray-300 border-solid font-bold text-lg p-4`}
`;

const NoticeAgreementTableSection = styled.div`
  ${tw`grid grid-cols-2 gap-4`}
  grid-template-columns: 67% 33%;
`;

const NoticeAgreementTableLeft = styled.div`
  ${tw`border border-gray-500 border-solid p-2`}
`;

const NoticeAgreementTableRight = styled.div`
  ${tw`pr-4`}
`;

const NoCoolingOffTitle = styled.b`
  ${tw`font-bold text-lg`}
`;

const NoCoolingOffDescription = styled.label`
  ${tw`text-base font-semibold`}
`;

const FooterNoteContainer = styled.div`
  ${tw`text-sm mt-2`}
`;

const OtherOwnerContainer = styled.div`
  ${tw`flex flex-row gap-2 mt-8 mb-6`}
`;

const GaranteeContainer = styled.div`
  ${tw`border border-gray-500 border-solid p-2`}
`;

const FooterText = styled.div`
  ${tw`text-xs text-gray-600 flex items-center justify-between`}
`;

const FormNumber = styled.span`
  ${tw`font-semibold`}
`;

const CopyType = styled.span`
  ${tw`text-right font-semibold text-red-600`}
`;

const FooterContainer = styled.div``;

const FinalSectionComponent = () => {
  return (
    <FinalSectionContainer>
      <NoticeToBuyer>
        Notice to buyer: (1) Do not sign this agreement before you read it or if it contains any
        blank spaces to be filled in. (2) You are entitled to a completely filled in copy of this
        agreement. (3) You can prepay the full amount due under this agreement at any time. (4) If
        you default in the performance of your obligations under this agreement, the vehicle may be
        repossessed and you may be subject to suit and liability for the unpaid indebtedness
        evidenced by this agreement.
      </NoticeToBuyer>
      <MutualAgreementSigns description="If you have a complaint concerning this sale, you should try to resolve it with the seller. Complaints concerning unfair or deceptive practices or methods by the seller may be referred to the city attorney, the district attorney, or an investigator for the Depariment of Motor Vehicles, or any combination thereof. After this contract is signed, the seller may not change the financing or payment terms unless you agree in writing to the change. You do not have to agree to any change, and it is an unfair or deceptive practice for the seller to make a unilateral change." />
      <MutualAgreementSigns
        showPrintName
        showDate
        titleInCenter="The Annual Percentage Rate may be negotiable with the Seller. The Seller may assign this contract and retain its right to receive a part of the Finance Charge."
        description="If you have a complaint concerning this sale, you should try to resolve it with the seller. Complaints concerning unfair or deceptive practices or methods by the seller may be referred to the city attorney, the district attorney, or an investigator for the Depariment of Motor Vehicles, or any combination thereof. After this contract is signed, the seller may not change the financing or payment terms unless you agree in writing to the change. You do not have to agree to any change, and it is an unfair or deceptive practice for the seller to make a unilateral change."
        children={
          <NoticeAgreementTableSection>
            <NoticeAgreementTableLeft>
              <NoCoolingOffTitle>
                THERE IS NO COOLING-OFF PERIOD UNLESS YOU OBTAIN A CONTRACT CANCELLATION OPTION.
              </NoCoolingOffTitle>
              <NoCoolingOffDescription>
                California law does not provide for a "cooling-off" or other cancellation period for
                vehicle sales. Therefore, you cannot later cance this contract simply because you
                change your mind, decide the vehicle costs too much, or wish you had acquired a
                different vehicle. After you sign below, you may only cancel this contract with the
                agreement of the seller or for legal cause, such as fraud. However, California law
                does require a seller to offer a two-day contract cancellation option on used
                vehicles with a purchase price of less than forty thousand dollars ($40,000),
                subject to certain statutory conditions. This contract cancellation option
                requirement does not apply to the sale of a recreational venicle, a motorcycle, or
                an off-highway motor vehicle subject to identification under California law. See the
                vehicle contract cancellation option agreement for details.
              </NoCoolingOffDescription>
            </NoticeAgreementTableLeft>
            <NoticeAgreementTableRight>
              <NoCoolingOffDescription>
                YOU AGREE TO THE TERMS OF THIS CONTRACT. YOU CONFIRM THAT BEFORE YOU SIGNED THIS
                CONTRACT, WE GAVE IT TO YOU, AND YOU WERE FREE TO TAKE IT AND REVIEW IT. YOU
                ACKNOWLEDGE THAT YOU HAVE READ BOTH SIDES OF THIS CONTRACT, INCLUDING THE
                ARBITRATION PROVISION ON THE REVERSE SIDE, BEFORE SIGNING BELOW. YOU CONFIRM THAT
                YOU RECEIVED A COMPLETELY FILLED-IN COPY WHEN YOU SIGNED IT.
              </NoCoolingOffDescription>
            </NoticeAgreementTableRight>
          </NoticeAgreementTableSection>
        }
        footerNote={
          <FooterNoteContainer>
            <span>If the "business" use box is checked in "Primary Use for Which Purchased":</span>
            <span>Print Name__________________________Title___________________________</span>
            <div>
              Co-Buyers and Other Owners - A co-buyer is a person who is responsible for paying the
              entire debt. An other owner is a person whose name is on the title to the vehicle but
              does not have to pay the debt. The other owner agrees to the security interest in the
              vehicle given to us in this contract.
            </div>
            <OtherOwnerContainer>
              <div>Other Owner Signature: X___________________________</div>
              <div>Address: ______________________________________________________________</div>
            </OtherOwnerContainer>
            <MutualAgreementSigns
              title="GUARANTY:"
              description="To induce us to sell the vehicle to Buyer, each person who signs as a Guarantor individually guarantees the payment of this contract. If Buyer fails to pay any money owing on this contract, each Guarantor must pay it when asked. Each Guarantor will be liable for the total amount owing even it other persons also sign as Guarantor, and even if Buyer has a complete defense to Guarantor's demand for reimbursement. Each Guarantor agrees to be liable even if we do one or more of the following: (1) give the Buyer more time to pay one or more payments; (2) give a full or partial release to any other Guarantor; (3) release any security; (4) accept less from the Buyer than the total amount owing; or (5) otherwise reach a settlement relating to this contract or extend the contract. Each Guarantor acknowledges receipt of a completed copy of this contract and guaranty at the time of signing. Guarantor waives notice of acceptance of this Guaranty, notice of the Buyer's non-payment, non-performance, and default; and notices of the amount owing at any time, and of any demands upon the Buyer."
              signerTitle="Guarantor X"
              coSignerTitle="Guarantor X"
              showSignerAddress
            />
          </FooterNoteContainer>
        }
      />
    </FinalSectionContainer>
  );
};

export default FinalSectionComponent;
